var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../LayoutDesigner/LayoutElement", "../ConfigurationDesigner/ConfigurationContentElement", "../ConfigurationDesigner/ConfigurationContainerElement", "../ConfigurationDesigner/ConfigurationVirtualScreenElement", "../LayoutDesigner/LayoutDesigner", "../Shared/Rect", "../Shared/Helper", "ts-vector-math"], function (require, exports, LayoutElement_1, ConfigurationContentElement_1, ConfigurationContainerElement_1, ConfigurationVirtualScreenElement_1, LayoutDesigner_1, Rect_1, Helper_1, ts_vector_math_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ConfigurationDesigner = (function (_super) {
        __extends(ConfigurationDesigner, _super);
        function ConfigurationDesigner(root, id) {
            if (id === void 0) { id = ""; }
            var _this = _super.call(this, root, id) || this;
            _this.scaleRatio = 1.0;
            _this.allowDeepEdit = true;
            _this.containerLayoutTemplate = "<div></div>";
            _this.maxDimensionWidth = 3000;
            _this.debug = false;
            var screenWidth = $(window).width();
            _this.activeLayer = -1;
            _this.ScaleRatio = 1;
            return _this;
        }
        Object.defineProperty(ConfigurationDesigner.prototype, "ScaleRatio", {
            get: function () { return this.scaleRatio; },
            set: function (value) {
                this.scaleRatio = value;
                this.finalScale = this.scaleRatio / 2.0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ConfigurationDesigner.prototype, "AllowDeepEdit", {
            get: function () { return this.allowDeepEdit; },
            set: function (value) {
                this.allowDeepEdit = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ConfigurationDesigner.prototype, "FinalScale", {
            get: function () { return this.finalScale; },
            enumerable: true,
            configurable: true
        });
        ConfigurationDesigner.prototype.IsVirtualScreen = function (object) {
            if (object.PhysicalScreens !== undefined)
                return true;
            return false;
        };
        ConfigurationDesigner.prototype.IsContent = function (object) {
            if (object.Type !== undefined)
                return true;
            return false;
        };
        ConfigurationDesigner.prototype.IsMultiScreen = function (object) {
            if (this.IsContent(object)) {
                var content = object;
                if (content.Type == "multiscreen" || content.Type == "sujet")
                    return true;
            }
            return false;
        };
        ConfigurationDesigner.prototype.IsSujet = function (object) {
            if (this.IsContent(object)) {
                var content = object;
                if (content.Type == "sujet")
                    return true;
            }
            return false;
        };
        ConfigurationDesigner.prototype.IsContainerEditable = function (container) {
            if (container instanceof ConfigurationContainerElement_1.ConfigurationContainerElement) {
                var confContainer = container;
                return confContainer.IsEditable;
            }
            return true;
        };
        ConfigurationDesigner.prototype.CreateContentRecursively = function (object, container, parentElement, layerIndex, iteration) {
            if (layerIndex === void 0) { layerIndex = 0; }
            if (iteration === void 0) { iteration = 0; }
            iteration++;
            if (object == null) {
                this.CreateDummyContent(container, parentElement, layerIndex);
                return;
            }
            if (this.IsVirtualScreen(object)) {
                if (this.debug)
                    console.log("CreateContentRecursively: VirtualScreen found");
                parentElement.containerObject = container;
                this.CreateContentRecursively(object.Content, object, parentElement, layerIndex, 0);
                return;
            }
            if (this.IsMultiScreen(object)) {
                if (this.debug)
                    console.log("CreateContentRecursively: MultiScreen found");
                var mScreen = object;
                var containerElement = this.CreateMultiScreenContainer(container, parentElement, layerIndex, object);
                containerElement.Level = iteration;
                if (this.IsSujet(object)) {
                    if (this.AllowDeepEdit || (this.AllowDeepEdit == false && iteration > 1))
                        containerElement.AddNameFromObject();
                    if (this.AllowDeepEdit == false && iteration > 1) {
                        containerElement.IsEditable = false;
                        containerElement.AddInactiveLayer();
                    }
                }
                for (var _i = 0, _a = mScreen.Layers; _i < _a.length; _i++) {
                    var layer = _a[_i];
                    for (var _b = 0, _c = layer.ViewPorts; _b < _c.length; _b++) {
                        var viewPort = _c[_b];
                        this.CreateContentRecursively(viewPort.Content, viewPort, containerElement, layer.zIndex, iteration);
                    }
                }
                return;
            }
            if (this.IsContent(object)) {
                var content = object;
                this.CreateContent(content, container, parentElement, layerIndex);
            }
        };
        ConfigurationDesigner.prototype.CreateDummyContent = function (container, parentElement, layerIndex) {
            if (layerIndex === void 0) { layerIndex = 0; }
            var rect = this.GetRectFromContainer(container, parentElement);
            var contentElement = this.CreateContentElement(rect, parentElement);
            contentElement.LayerIndex = layerIndex;
            contentElement.containerObject = container;
            this.CreateContentElementsImageIcon(contentElement, null, "add");
            return contentElement;
        };
        ConfigurationDesigner.prototype.CreateMultiScreenContainer = function (container, parentElement, layerIndex, object) {
            if (layerIndex === void 0) { layerIndex = 0; }
            if (object === void 0) { object = null; }
            var rect = this.GetRectFromContainer(container, parentElement);
            var containerElement = this.CreateContainerElement(rect, parentElement);
            containerElement.LayerIndex = layerIndex;
            containerElement.containerObject = container;
            containerElement.object = object;
            return containerElement;
        };
        ConfigurationDesigner.prototype.SetContent = function (object, contentElement) {
            var content = object;
            contentElement.object = content;
            contentElement.containerObject.Content = content;
            if (contentElement.containerObject.ContentId !== undefined)
                contentElement.containerObject.ContentId = content.Id;
            this.DeleteLayoutElement(contentElement);
            this.CreateContentRecursively(content, contentElement.containerObject, contentElement.parentLayoutElement, contentElement.LayerIndex, contentElement.parentLayoutElement.Level);
        };
        ConfigurationDesigner.prototype.EditContentElement = function (sender, data) {
            this.FireEvent(LayoutElement_1.LayoutElement.OnElementEdit, { contentElement: data.element });
        };
        ConfigurationDesigner.prototype.DeleteContentElement = function (sender, data) {
            var layoutElement = data.element;
            console.log("DeleteContentElement:" + layoutElement.id);
            if (layoutElement.childrenLayoutElements != null)
                if (layoutElement.childrenLayoutElements.length > 0) {
                    var container = layoutElement.childrenLayoutElements[0].containerObject;
                    container.Content = null;
                    container.ContentId = "";
                    this.DeleteElementRecursively(layoutElement);
                }
            var virtualScreen = layoutElement.object.VirtualScreen;
            var contentElement = this.CreateDummyContent(virtualScreen, layoutElement, layoutElement.LayerIndex);
            contentElement.ApplyTouch();
        };
        ConfigurationDesigner.prototype.DeleteContainerElement = function (sender, data) {
            var layoutElement = data.element;
            console.log("DeleteContainerElement:" + layoutElement.id);
            var container = layoutElement.containerObject;
            container.Content = null;
            container.ContentId = "";
            if (layoutElement.childrenLayoutElements != null)
                if (layoutElement.childrenLayoutElements.length > 0) {
                    this.DeleteElementRecursively(layoutElement);
                }
            var contentElement = this.CreateDummyContent(layoutElement.containerObject, layoutElement.parentLayoutElement, layoutElement.LayerIndex);
            contentElement.ApplyTouch();
            this.DeleteLayoutElement(layoutElement);
        };
        ConfigurationDesigner.prototype.CreateContent = function (content, container, parentElement, layerIndex) {
            if (layerIndex === void 0) { layerIndex = 0; }
            if (content.Type == "asset") {
                var asset = content;
                if (this.debug)
                    console.log("CreateContentView: " + content.Type + " found");
                var rect = this.GetRectFromContainer(container, parentElement);
                var contentElement = this.CreateContentElement(rect, parentElement, layerIndex);
                contentElement.object = content;
                contentElement.containerObject = container;
                this.CreateContentElementsImageIcon(contentElement, asset, asset.AssetType);
                this.CreateContentElementsName(contentElement, content);
            }
            else if (content.Type == "scheduler") {
                if (this.debug)
                    console.log("CreateContentView: " + content.Type + " found");
                var rect = this.GetRectFromContainer(container, parentElement);
                var contentElement = this.CreateContentElement(rect, parentElement, layerIndex);
                contentElement.object = content;
                contentElement.containerObject = container;
                this.CreateContentElementsImageIcon(contentElement, null, "scheduler");
                this.CreateContentElementsName(contentElement, content);
            }
            else if (content.Type == "playlist") {
                if (this.debug)
                    console.log("CreateContentView: " + content.Type + " found");
                var rect = this.GetRectFromContainer(container, parentElement);
                var contentElement = this.CreateContentElement(rect, parentElement, layerIndex);
                contentElement.object = content;
                contentElement.containerObject = container;
                this.CreateContentElementsImageIcon(contentElement, null, "playlist");
                this.CreateContentElementsName(contentElement, content);
            }
        };
        ConfigurationDesigner.prototype.CreateContentElement = function (rect, parentElement, layerIndex) {
            if (layerIndex === void 0) { layerIndex = 0; }
            var id = this.nextFreeId.toString();
            var contentElement = new ConfigurationContentElement_1.ConfigurationContentElement(rect.width, rect.height, rect.x, rect.y, this.designerId + "ContentElement" + id, parentElement);
            contentElement.IgnoreInteractions(true);
            contentElement.LayerIndex = layerIndex;
            contentElement.AddEventListener("ContentElementTouched", this.EditContentElement.bind(this));
            this.elements.push(contentElement);
            this.nextFreeId++;
            if (this.IsContainerEditable(parentElement) == false) {
                contentElement.UnsetInteraction();
                contentElement.IgnoreTapInteraction(true);
            }
            return contentElement;
        };
        ConfigurationDesigner.prototype.CreateContainerElement = function (rect, parentElement, layerIndex) {
            if (layerIndex === void 0) { layerIndex = 0; }
            var id = this.nextFreeId.toString();
            var containerElement = new ConfigurationContainerElement_1.ConfigurationContainerElement(rect.width, rect.height, rect.x, rect.y, this.designerId + "ContainerElement" + id, parentElement, this.containerLayoutTemplate);
            containerElement.IgnoreInteractions(true);
            containerElement.LayerIndex = layerIndex;
            containerElement.AddEventListener("EditContainerClicked", this.EditContentElement.bind(this));
            containerElement.AddEventListener("DeleteContainerElement", this.DeleteContainerElement.bind(this));
            this.elements.push(containerElement);
            this.nextFreeId++;
            return containerElement;
        };
        ConfigurationDesigner.prototype.CreateVirtualScreenContainerElement = function (rect, parentElement, layout) {
            if (layout === void 0) { layout = null; }
            var id = this.nextFreeId.toString();
            var containerElement = new ConfigurationVirtualScreenElement_1.ConfigurationVirtualScreenElement(rect.width, rect.height, rect.x, rect.y, this.designerId + "VirtualScreenContainerElement" + id, parentElement, layout);
            containerElement.AddEventListener("EditContainerClicked", this.EditContentElement.bind(this));
            containerElement.AddEventListener("DeleteContentClicked", this.DeleteContentElement.bind(this));
            containerElement.AddEventListener(LayoutElement_1.LayoutElement.OnElementTouched, this.ElementTouched.bind(this));
            containerElement.AddEventListener(LayoutElement_1.LayoutElement.OnElementDropped, this.ElementDropped.bind(this));
            containerElement.AddEventListener(LayoutElement_1.LayoutElement.OnElementMoved, this.ElementMoved.bind(this));
            this.elements.push(containerElement);
            this.nextFreeId++;
            return containerElement;
        };
        ConfigurationDesigner.prototype.CreateContentElementsName = function (configurationContentElement, content) {
            var name = content.Name;
            configurationContentElement.nameElement.find("*").filter("#name").html(name);
        };
        ConfigurationDesigner.prototype.CreateContentElementsImageIcon = function (configurationContentElement, asset, type) {
            if (asset !== null && asset.Thumbnail && asset.Thumbnail !== "")
                configurationContentElement.element.css({ 'background': 'url("/images/placeholder/thumb.' + type + '.png") 50% 50% no-repeat, url("' + asset.Thumbnail + '") 50% 50% no-repeat', 'background-size': '40px, cover' });
            else
                configurationContentElement.element.css("background-image", "url(\"/images/placeholder/thumb." + type + ".png\")");
        };
        ConfigurationDesigner.prototype.GetRectFromContainer = function (container, parentElement, rectOffset) {
            if (rectOffset === void 0) { rectOffset = null; }
            if (this.IsVirtualScreen(container)) {
                container = container;
                return this.GetRectFromVirtualScreen(container, new Rect_1.Rect(0, 0, 0, 0));
            }
            else {
                container = container;
                return this.GetRectFromViewPort(container, parentElement, rectOffset);
            }
        };
        ConfigurationDesigner.prototype.GetRectFromVirtualScreen = function (container, rectOffset) {
            if (rectOffset === void 0) { rectOffset = null; }
            var width = container.Dimension.Width;
            var height = container.Dimension.Height;
            var size = new ts_vector_math_1.Vector2([width, height]);
            size = Helper_1.Helper.Vector2.GetMaxSize(size, this.maxDimensionWidth);
            width = size.x * this.finalScale;
            height = size.y * this.finalScale;
            var x = 0;
            var y = 0;
            if (rectOffset != null) {
                width += rectOffset.width;
                height += rectOffset.height;
                x += rectOffset.x;
                y += rectOffset.y;
            }
            var rect = new Rect_1.Rect(x, y, width, height);
            return rect;
        };
        ConfigurationDesigner.prototype.GetRectFromViewPort = function (container, parentElement, rectOffset) {
            if (rectOffset === void 0) { rectOffset = null; }
            var width = parentElement.ContentElement.width() * container.PercentW;
            var height = parentElement.ContentElement.height() * container.PercentH;
            var x = parentElement.ContentElement.width() * container.PercentX;
            var y = parentElement.ContentElement.height() * container.PercentY;
            if (rectOffset != null) {
                width += rectOffset.width;
                height += rectOffset.height;
                x += rectOffset.x;
                y += rectOffset.y;
            }
            var rect = new Rect_1.Rect(x, y, width, height);
            return rect;
        };
        return ConfigurationDesigner;
    }(LayoutDesigner_1.LayoutDesigner));
    exports.ConfigurationDesigner = ConfigurationDesigner;
});
//# sourceMappingURL=ConfigurationDesigner.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/ConfigurationDesigner/ConfigurationDesigner.js
// module id = 162
// module chunks = 0